// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__310qk","consentsList":"PatientConsents_consentsList__398IX","consentsListEmpty":"PatientConsents_consentsListEmpty__p6Cgb"};